module.exports = __webpack_public_path__ + "img/down.9b5cea7a.svg";